module.exports = __webpack_public_path__ + "img/next-active.144282fb.svg";